module.exports = __webpack_public_path__ + "img/stldispatch_success.eec3e432.svg";